import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Search as SearchIcon,
} from '@mui/icons-material';
import SearchModal from './SearchModal';

const SearchButton: React.FC = () => {
  const [searchModalOpen, setSearchModalOpen] = useState(false);

  // Handle global keyboard shortcut (Cmd+K / Ctrl+K)
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        setSearchModalOpen(true);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSearchClick = () => {
    setSearchModalOpen(true);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      setSearchModalOpen(true);
    }
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, maxWidth: 400, mx: 3 }}>
        <TextField
          fullWidth
          size="small"
          placeholder="Search diseases, treatments..."
          variant="outlined"
          onClick={handleSearchClick}
          onKeyDown={handleKeyDown}
          InputProps={{
            readOnly: true,
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Press Enter or click to search">
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: 1,
                      px: 1,
                      py: 0.5,
                      fontSize: '0.75rem',
                      color: 'rgba(255, 255, 255, 0.7)',
                      fontWeight: 'medium',
                    }}
                  >
                    ⌘K
                  </Box>
                </Tooltip>
              </InputAdornment>
            ),
            sx: {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              '& fieldset': {
                border: '1px solid rgba(255, 255, 255, 0.2)',
              },
              '&:hover fieldset': {
                border: '1px solid rgba(255, 255, 255, 0.3)',
              },
              '&.Mui-focused fieldset': {
                border: '1px solid rgba(255, 255, 255, 0.4)',
              },
              '& input': {
                color: 'white',
                cursor: 'pointer',
                '&::placeholder': {
                  color: 'rgba(255, 255, 255, 0.7)',
                  opacity: 1,
                },
              },
            },
          }}
        />
      </Box>

      <SearchModal
        open={searchModalOpen}
        onClose={() => setSearchModalOpen(false)}
      />
    </>
  );
};

export default SearchButton;
